import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { CategoryGrid } from './components/CategoryGrid';
import { Newsletter } from './components/Newsletter';
import { AboutSection } from './components/AboutSection';
import { Founder } from './components/Founder';
import { Footer } from './components/Footer';
import { Location } from './components/Location';
import { Lookbook } from './pages/Lookbook';
import { LookbookDetail } from './pages/LookbookDetail';
import { About } from './pages/About';
import { Collection } from './pages/Collection';
import { Booking } from './pages/Booking';
import { NewIn } from './pages/NewIn';
import { HisAndHers } from './pages/HisAndHers';
import { Women } from './pages/Women';
import { Men } from './pages/Men';
import { Kids } from './pages/Kids';
import { Accessories } from './pages/Accessories';
import { Sale } from './pages/Sale';
import { Fabric } from './pages/Fabric';
import { SkinCare } from './pages/SkinCare';
import { GenericCollection } from './pages/GenericCollection';
import { ScrollToTop } from './components/ScrollToTop';
import { AnimatePresence, motion } from 'framer-motion';
const pageVariants = {
  initial: {
    opacity: 0,
    y: 10
  },
  animate: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: -10
  }
};
const PageWrapper = ({
  children
}: {
  children: React.ReactNode;
}) => <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={{
  duration: 0.4,
  ease: 'easeOut'
}} data-id="element-0">
    {children}
  </motion.div>;
function Home() {
  return <main className="flex-grow" data-id="element-1">
      <Hero data-id="element-2" />
      <Newsletter data-id="element-3" />
      <AboutSection data-id="element-4" />
      <CategoryGrid data-id="element-5" />
      <Location data-id="element-6" />
    </main>;
}
export function App() {
  const location = useLocation();
  return <div className="min-h-screen flex flex-col selection:bg-black selection:text-white" data-id="element-7">
      <ScrollToTop data-id="element-8" />
      <Header data-id="element-9" />
      <AnimatePresence mode="wait" data-id="element-10">
        <Routes location={location} key={location.pathname} data-id="element-11">
          <Route path="/" element={<PageWrapper data-id="element-13">
                <Home data-id="element-14" />
              </PageWrapper>} data-id="element-12" />
          <Route path="/lookbook" element={<PageWrapper data-id="element-16">
                <Lookbook data-id="element-17" />
              </PageWrapper>} data-id="element-15" />
          <Route path="/lookbook/:id" element={<PageWrapper data-id="element-19">
                <LookbookDetail data-id="element-20" />
              </PageWrapper>} data-id="element-18" />
          <Route path="/about" element={<PageWrapper data-id="element-22">
                <About data-id="element-23" />
              </PageWrapper>} data-id="element-21" />
          <Route path="/collection/:category" element={<PageWrapper data-id="element-25">
                <Collection data-id="element-26" />
              </PageWrapper>} data-id="element-24" />
          <Route path="/booking" element={<PageWrapper data-id="element-28">
                <Booking data-id="element-29" />
              </PageWrapper>} data-id="element-27" />

          <Route path="/new-in" element={<PageWrapper data-id="element-31">
                <NewIn data-id="element-32" />
              </PageWrapper>} data-id="element-30" />
          <Route path="/his-&-hers" element={<PageWrapper data-id="element-34">
                <HisAndHers data-id="element-35" />
              </PageWrapper>} data-id="element-33" />
          <Route path="/daddy-&-me" element={<PageWrapper data-id="element-37">
                <GenericCollection title="Daddy & Me" description="Matching heritage for fathers and sons." data-id="element-38" />
              </PageWrapper>} data-id="element-36" />
          <Route path="/mommy-&-me" element={<PageWrapper data-id="element-40">
                <GenericCollection title="Mommy & Me" description="Coordinated elegance for mothers and daughters." data-id="element-41" />
              </PageWrapper>} data-id="element-39" />
          <Route path="/women" element={<PageWrapper data-id="element-43">
                <Women data-id="element-44" />
              </PageWrapper>} data-id="element-42" />
          <Route path="/curve-collection" element={<PageWrapper data-id="element-46">
                <GenericCollection title="Curve Collection" description="Empowering silhouettes for every curve." data-id="element-47" />
              </PageWrapper>} data-id="element-45" />
          <Route path="/men" element={<PageWrapper data-id="element-49">
                <Men data-id="element-50" />
              </PageWrapper>} data-id="element-48" />
          <Route path="/kids" element={<PageWrapper data-id="element-52">
                <Kids data-id="element-53" />
              </PageWrapper>} data-id="element-51" />
          <Route path="/unisex" element={<PageWrapper data-id="element-55">
                <GenericCollection title="Unisex" description="Fluid heritage for everyone." data-id="element-56" />
              </PageWrapper>} data-id="element-54" />
          <Route path="/accessories" element={<PageWrapper data-id="element-58">
                <Accessories data-id="element-59" />
              </PageWrapper>} data-id="element-57" />
          <Route path="/sale" element={<PageWrapper data-id="element-61">
                <Sale data-id="element-62" />
              </PageWrapper>} data-id="element-60" />
          <Route path="/fabric" element={<PageWrapper data-id="element-64">
                <Fabric data-id="element-65" />
              </PageWrapper>} data-id="element-63" />
          <Route path="/coquette-natural-skin-care-collection" element={<PageWrapper data-id="element-67">
                <SkinCare data-id="element-68" />
              </PageWrapper>} data-id="element-66" />
        </Routes>
      </AnimatePresence>
      <Footer data-id="element-69" />
    </div>;
}
export function Root() {
  return <Router data-id="element-70">
      <App data-id="element-71" />
    </Router>;
}